import React from 'react'
import OpenAccount from '../OpenAccount'


function Signup() {
    return (
        <div className='' id='signup'>
            <div className=' row text-center p-5 my-5'>
                <h2>Open a free demat and trading account online</h2>
                <p className='fs-4 text-muted'>Start investing brokerage free and join a community of 1.6+ crore investors and traders</p>
            </div>


            <div className='row' style={{ paddingInline: '5rem', paddingLeft: '12rem', paddingBottom: '5rem' }}>
                <div className='col-6' >
                    <img src='media/account_open.svg' alt='img' style={{ width: "80%" }} />
                </div>
                <div className='col-6' style={{}}>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '0.6rem' }}>
                        <h2>Signup now</h2>
                        <p className='text-muted'>Or track your existing application <b>signup in Kite only</b></p>
                        <div class="input-group" style={{ width: "57%", height: '4rem' }}>
                            <span class="input-group-text" id="visible-addon"><img src='media/india-flag.svg' alt='img' style={{ width: "80%" }} /> + 91 </span>
                            <input type="text" class="form-control" placeholder="Just click on button & your mobile number" aria-label="Username" aria-describedby="visible-addon" />
                        </div>
                        <a href="https://zerodha-clone-kite.onrender.com" target='_blank'>
                            <button className='p-3 btn btn-primary fs-5 mb-5' style={{ width: "57%" }}>Go to Kite Website </button>
                        </a>
                        <p className='text-muted fs-6'>By proceeding, you agree to the Zerodha <a href='' style={{ textDecoration: 'none' }} >terms & privacy policy</a></p>
                        <p className='text-muted fs-6'>Looking to open NRI account? <a href='' style={{ textDecoration: 'none' }} >Click here</a> </p>
                    </div>
                </div>
            </div>


            <div className=' row text-center p-3 my-3'>
                <h4>Investment options with Zerodha demat account</h4>
            </div>


            <div className='row' style={{ padding: '2rem', gap: '4rem' }}>
                <div className='col' style={{ display: 'flex', justifyContent: 'end', gap: '3rem' }}>
                    <div className=''>
                        <img src='media/stocks-acop.svg' alt='img' />
                    </div>
                    <div className='' >
                        <div>
                            <div>
                                <h5 className=''>Stocks</h5>
                                <p>Invest in all exchange-listed <br />securities</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='col' style={{ display: 'flex', justifyContent: 'start', gap: '3rem' }}>
                    <div className=''>
                        <img src='media/mf-acop.svg' alt='img' />
                    </div>
                    <div className=''>
                        <div>
                            <div>
                                <h5 className=''>Mutual funds</h5>
                                <p>Invest in commission-free direct<br /> mutual funds</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <div className='row' style={{ padding: '2rem', gap: '4rem' }}>
                <div className='col' style={{ display: 'flex', justifyContent: 'end', gap: '3rem' }}>
                    <div className=''>
                        <img src='media/ipo-acop.svg' alt='img' />
                    </div>
                    <div className='' >
                        <div>
                            <div>
                                <h5 className=''>IPO</h5>
                                <p>Apply to the latest IPOs<br /> instantly via UPI</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='col' style={{ display: 'flex', justifyContent: 'start', gap: '3rem' }}>
                    <div className=''>
                        <img src='media/fo-acop.svg' alt='img' />
                    </div>
                    <div className=''>
                        <div>
                            <div>
                                <h5 className=''>Futures & options</h5>
                                <p>Hedge and mitigate market risk<br /> through simplified F&O trading</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <div className=' row text-center p-2 my-5'>
                <button className='p-3 btn btn-primary fs-5 mb-5' style={{ width: "17%", margin: "0 auto" }}>Explore Investments</button>
            </div>
            <div className='row bg-light' style={{ paddingInline: "90px", margin: '0', padding: '4rem' }}>
                <div className='col-12 text-center'>
                    <h4>Steps to open a demat account with Zerodha</h4>
                </div>
                <div className='col-6 py-5'>
                    <img src='media/steps-acop.svg' alt='img' />
                </div>
                <div className='col-6' style={{ padding: "100px" }}>
                    <div>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '2rem' }}>
                            <h5 className='border-bottom py-3'> 1. Enter the requested details</h5>
                            <h5 className='border-bottom py-3'> 2. Complete e-sign & verification</h5>
                            <h5 className='border-bottom py-3'> 3. Start investing!</h5>
                        </div>
                    </div>
                </div>
            </div>


            <div className='row' style={{ paddingInline: "12rem", margin: '0', alignItems: 'center' }}>
                <div className='col-6' style={{ textAlign: 'center' }}>
                    <img src='media/acop-benefits.svg' alt='img' style={{ width: '75%' }} />
                    <h4 className=''>Benefits of opening a Zerodha demat account</h4>
                </div>
                <div className='col-6' style={{ padding: "100px", display: 'flex', flexDirection: 'column', gap: '3rem' }}>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                        <h5 className=''>Unbeatable pricing</h5>
                        <h7 className='text-muted'>Zero charges for equity & mutual fund investments. Flat ₹20 fees for intraday and F&O trades.</h7>
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                        <h5 className=''>Best investing experience</h5>
                        <h7 className='text-muted'>Simple and intuitive trading platform with an easy-to-understand user interface.</h7>
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                        <h5 className=''>No spam or gimmicks</h5>
                        <h7 className='text-muted'>Committed to transparency — no gimmicks, spam, "gamification", or intrusive push notifications.</h7>
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                        <h5 className=''>The Zerodha universe</h5>
                        <h7 className='text-muted'>More than just an app — gain free access to the entire ecosystem of our partner products.</h7>
                    </div>
                </div>
            </div>

            <div className='row text-center pb-5'>
                <h3>Explore different account types</h3>
            </div>

            <div className='row' style={{paddingInline:'12rem', paddingBlock:'5rem'}} >
                <div className='col'>
                    <div class="card" style={{ width: '20rem', height:'10rem', padding:'1rem'}}>
                        <div class="card-body">
                            <h5 class="card-title"><i class="fa fa-user-circle-o" aria-hidden="true"></i> Individual Account</h5><br/>
                            <p class="card-text" className='text-muted'>Invest in equity, mutual funds and derivatives</p>
                        </div>
                    </div>
                </div>
                <div className='col'>
                    <div class="card" style={{ width: '20rem', height:'10rem', padding:'1rem'}}>
                        <div class="card-body">
                            <h5 class="card-title"><i class="fa fa-adjust" aria-hidden="true"></i> HUF Account</h5><br/>
                            <p class="card-text" className='text-muted'>Make tax-efficient investments for your family</p>
                        </div>
                    </div>
                </div>
                <div className='col'>
                    <div class="card" style={{ width: '20rem', height:'10rem', padding:'1rem'}}>
                        <div class="card-body">
                            <h5 class="card-title"><i class="fa fa-fire" aria-hidden="true"></i> NRI Account</h5><br/>
                            <p class="card-text"  className='text-muted'>Invest in equity, mutual funds, debenatures, and more</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className='row' style={{paddingInline:'12rem', paddingBottom:'5rem'}} >
                <div className='col'>
                    <div class="card" style={{ width: '20rem', height:'10rem', padding:'1rem'}}>
                        <div class="card-body">
                            <h5 class="card-title"><i class="fa fa-handshake-o" aria-hidden="true"></i> Minor Account</h5><br/>
                            <p class="card-text" className='text-muted'>Teachs your little one about money & invest for their future with them</p>
                        </div>
                    </div>
                </div>
                <div className='col'>
                    <div class="card" style={{ width: '20rem', height:'10rem', padding:'1rem'}}>
                        <div class="card-body">
                            <h6 class="card-title"><i class="fa fa-users" aria-hidden="true"></i> Corporate / LLPP /Parrtenership</h6><br/>
                            <p class="card-text" className='text-muted'>Manage your business surplus and investments easily</p>
                        </div>
                    </div>
                </div>
                <div className='col'>
                    {/* <div class="card" style={{ width: '20rem', height:'10rem', padding:'1rem'}}>
                        <div class="card-body">
                            <h5 class="card-title"><i class="fa fa-adjust" aria-hidden="true"></i> NRI Account</h5><br/>
                            <p class="card-text"  className='text-muted'>Invest in equity, mutual funds, debenatures, and more</p>
                        </div>
                    </div> */}
                </div>
            </div>





            <OpenAccount />
        </div>

    );
}

export default Signup;